import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import requests from '../../../axios/requests'
import variableLanguage from '../../../utils/hooks/hookGetVariablesLanguage'
import { Popconfirm, Tooltip } from 'antd'
import { useDispatch } from 'react-redux'
import {
  changeLanguage,
  setActiveModules,
  setEndTrialDate,
  setStatusTrial,
} from '../../../../redux/actions/actions'
import cn from 'classnames'

import fake_photos from '../../../../images/icons/fake_photos.png'
import { ReactComponent as NavBarNotification } from '../../../../images/icons/navbar_notification.svg'
import { ReactComponent as NavBarCase } from '../../../../images/icons/nav_bar-course.svg'
import { ReactComponent as SidebarModule } from '../../../../images/icons/sidebar_module.svg'
import { ReactComponent as AcademicPlan } from '../../../../images/icons/nav_bar-case.svg'
import { ReactComponent as Logout } from '../../../../images/icons/logout.svg'
import { ReactComponent as HistoryPay } from '../../../../images/icons/history_pay.svg'
import { ReactComponent as Logo } from '../../../../images/icons/logo.svg'
import { ReactComponent as MailIcon } from '../../../../images/icons/mail.svg'
import Transition from '../Transition/Transition'
import './MobileSidebarNew.scss'
import { useSelector } from 'react-redux'

const MobileSidebarNew = ({ flagHiddenFotter }) => {
  const history = useNavigate()
  const { pathname } = useLocation()
  const [countNotification, setCountNotification] = useState(null)
  const [changeLanguageFlag, setChangeLanguageFlag] = useState(false)
  const { collapse } = useSelector((state) => state.Reducer)
  const dispatch = useDispatch()

  const variable_1 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_1',
  })
  const variable_2 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_2',
  })
  const variable_3 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_3',
  })
  const variable_4 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_4',
  })
  const variable_5 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_5',
  })
  const variable_6 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_6',
  })
  const variable_7 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_7',
  })
  const variable_8 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_8',
  })
  const variable_9 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_9',
  })
  const variable_10 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_10',
  })
  const variable_11 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_11',
  })
  const variable_12 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_12',
  })
  const variable_14 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_14',
  })
  const variable_15 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_15',
  })
  const variable_16 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_16',
  })

  let getCountNotificationInterval = () => {
    setCountNotification(localStorage.getItem('count_notification'))
  }

  let handleLogOut = async () => {
    await requests.auth.logout().catch((err) => console.error(err))
    dispatch(setActiveModules([]))
    dispatch(setEndTrialDate(''))
    dispatch(setStatusTrial(null))
    window.localStorage.removeItem('user_id')
    window.localStorage.removeItem('name')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('photo')
    history(`/backoffice/login`)
  }
  useEffect(() => {
    getCountNotificationInterval()
    setInterval(() => {
      getCountNotificationInterval()
    }, 1000)
  }, [])
  return (
    <>
      {flagHiddenFotter && (
        <>
          <>
            <div className="group_mobile">
              <div
                className={pathname === '/backoffice/my-course' ? 'active' : ''}
                onClick={() => history('/backoffice/my-course')}
              >
                {variable_8}
              </div>
              <div
                className={pathname === '/backoffice/request-members' ? 'active' : ''}
                onClick={() => history('/backoffice/request-members')}
              >
                {variable_9}
              </div>
              <div
                className={pathname === '/backoffice/groups-list' ? 'active' : ''}
                onClick={() => history('/backoffice/groups-list')}
              >
                {variable_10}
              </div>
            </div>
          </>

          <div className="bar_mobile">
            <Logo
              width={38}
              height={38}
              onClick={() => window.open('https://skillometer.ru/education', 'blank')}
            />
            <div
              className="bar_mobile_item"
              onClick={() => {
                history('/notification')
              }}
            >
              <div
                className={
                  window.location.href.includes('notification')
                    ? 'notification_svg active'
                    : 'notification_svg'
                }
              >
                <NavBarNotification width={34} height={34} />
                {countNotification && countNotification > 0 && (
                  <div className="count_notification">
                    <span>{countNotification > 99 ? '99+' : countNotification}</span>
                  </div>
                )}
              </div>
              <div className="bar_mobile_title">{variable_6}</div>
            </div>
            <div
              className="bar_mobile_item"
              onClick={() => {
                history('/backoffice/profile')
              }}
            >
              <img
                width={38}
                height={38}
                alt="my_photo"
                src={localStorage.getItem('photo') || fake_photos}
                id="photo"
              />
              <div className="bar_mobile_title">{variable_4}</div>
            </div>
            <div className="bar_mobile_item" onClick={() => history('/backoffice/academic-plan')}>
              <div
                className={
                  window.location.href.includes('/backoffice/academic-plan')
                    ? 'active academic-plan-svg'
                    : 'academic-plan-svg'
                }
              >
                <AcademicPlan />
              </div>
              <div className="bar_mobile_title">{variable_15}</div>
            </div>
            <div
              className="bar_mobile_item"
              onClick={() => {
                history('/backoffice/my-course')
              }}
            >
              <NavBarCase
                width={38}
                height={38}
                className={
                  !window.location.href.includes('/notification') &&
                  !window.location.href.includes('/history-pay') &&
                  !window.location.href.includes('/modules') &&
                  !window.location.href.includes('/profile') &&
                  !window.location.href.includes('/backoffice/academic-plan')
                    ? 'active my-course-svg'
                    : 'my-course-svg'
                }
              />
              <div className="bar_mobile_title">{variable_5}</div>
            </div>
            <div
              className="bar_mobile_item"
              onClick={() => {
                history('/backoffice/history-pay')
              }}
            >
              <HistoryPay
                width={38}
                height={38}
                className={
                  window.location.href.includes('/history-pay')
                    ? 'active history_pay-svg'
                    : 'history_pay-svg'
                }
              />
              <div className="bar_mobile_title">{variable_11}</div>
            </div>
            <div
              className="bar_mobile_item"
              onClick={() => {
                history('/backoffice/modules')
              }}
            >
              <SidebarModule
                width={38}
                height={38}
                className={
                  window.location.href.includes('/modules') ? 'active  modules-svg' : ' modules-svg'
                }
              />
              <div className="bar_mobile_title">{variable_12}</div>
            </div>
            <Tooltip placement="right" title={`${variable_16} support@skillometer.ru`}>
              <div className="support_bar" tabIndex={0}>
                <MailIcon className="support-icon" />
                <Transition show={collapse}>
                  <div className="support-text">
                    <div>{variable_16}</div>
                    <div>support@skillometer.ru</div>
                  </div>
                </Transition>
              </div>
            </Tooltip>
            <div
              className="change_parent"
              tabIndex={0}
              onClick={() => setChangeLanguageFlag(!changeLanguageFlag)}
              onBlur={() => setChangeLanguageFlag(false)}
            >
              <div className={changeLanguageFlag ? 'change_language open' : 'change_language'}>
                {!changeLanguageFlag && (
                  <div className="active">
                    {localStorage.getItem('language') === 'en' ? 'EN' : 'RU'}
                  </div>
                )}
                {changeLanguageFlag && (
                  <>
                    <div
                      className={localStorage.getItem('language') === 'ru' && 'active'}
                      onClick={() => {
                        dispatch(changeLanguage('ru'))
                        localStorage.setItem('language', 'ru')
                        setChangeLanguageFlag(false)
                      }}
                    >
                      RU
                    </div>
                    <div
                      className={localStorage.getItem('language') === 'en' && 'active'}
                      onClick={() => {
                        dispatch(changeLanguage('en'))
                        localStorage.setItem('language', 'en')
                        setChangeLanguageFlag(false)
                      }}
                    >
                      EN
                    </div>
                  </>
                )}
                {collapse && <span className="change_language-collapse">{variable_14} </span>}
              </div>
            </div>
            <div className="bar_mobile_item">
              <Popconfirm
                title={variable_1}
                onConfirm={() => handleLogOut()}
                okText={variable_2}
                cancelText={variable_3}
              >
                <Logout width={38} height={38} />
              </Popconfirm>
              <div className="bar_mobile_title">{variable_7}</div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default MobileSidebarNew
